import './loadersvg.scss';

interface LoaderSVGProps {
  width: any;
  height: any;
  className: any;
  bgcolor: any;
}
const LoaderSVG: React.FC<LoaderSVGProps> = ({ width, height, className, bgcolor }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <path d="M 50,50 L 33,60.5 a 20 20 -210 1 1 34,0 z" fill="#595959">
        <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1.2s" repeatCount="indefinite" />
      </path>
      <circle cx="50" cy="50" r="16" fill={bgcolor}></circle>
    </svg>
  );
}
export default LoaderSVG;